'use strict';

jQuery($ => {
	function gecko_floor_plans(){
		$('.floor-select').each(function(){
			//console.log(this);
			if(this.checked){
				$(this.value).addClass('show');
				$(this).parent().find('.fa').removeClass('fa-circle-o').addClass('fa-circle');
			}else{
				$(this.value).removeClass('show');
				$(this).parent().find('.fa').removeClass('fa-circle').addClass('fa-circle-o');
			}
		});
	}
	function gecko_room_layout(){
		$('.room-layout').each(function(){
			//console.log(this);
			if(this.checked){
				$('.gecko-floor-plans__plan ' + this.value).show();
				//console.log(this.value);
				$(this).parent().find('.fa').removeClass('fa-square').addClass('fa-check-square');
			}else{
				$('.gecko-floor-plans__plan ' + this.value).hide();
				$(this).parent().find('.fa').removeClass('fa-check-square').addClass('fa-square');
			}
		});
	}
	function gecko_open_plan(plan){
		console.log(plan);
		$('#room-information').find('.gecko-floor-plans__room-image').css('background-image', 'url(/wp-content/themes/gecko-theme/images/floorplans/'+plan+'.jpg)');
		$('#room-information').find('.floor-unit-name').html(plan);
	}

	$('.floor-select').change(function(){
	 	gecko_floor_plans();
	});
	$('.room-layout').change(function(){
	 	gecko_room_layout();
	});

	gecko_floor_plans();
	gecko_room_layout();

	var index;
	var plans = ['Birch', 'Oak', 'Pine', 'Larch','Cedar','Maple','Alder','Aspen'];
	//console.log(selectors);
	$.each(plans, function(index, plan){
		console.log(index+':'+plan);
		$('[data-plan='+plan+']').addClass('open-modestbox gecko-floor-plans__room show').attr('data-open','room-information');
		$('[href=#'+plan+']').addClass('open-modestbox gecko-floor-plans__room show').attr('data-open','room-information');
		$('[data-plan='+plan+']').click(function(){
			var plan = $(this).data('plan');
			gecko_open_plan(plan);
		});
		$('[href=#'+plan+']').click(function(){
			var plan = $(this).data('room');
			gecko_open_plan(plan);
		});
	});

});
